export default __webpack_public_path__ + "static/media/food-img.0897dbce.svg";